import React, { useState, useEffect } from 'react'
import { 
  ArrowLeft,
  ChevronRight,
  Calendar,
  Edit
} from 'lucide-react'
import { useNavigate, useLocation } from 'react-router-dom'
// Consolidated CSS is imported globally'

const DropdownMasterView = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dropdownData = location.state?.rowData

  const [formData, setFormData] = useState({
    dropdownCategory: '',
    label: '',
    value: '',
    order: 1,
    status: 'Active',
    createdDate: '24-09-2025'
  })

  useEffect(() => {
    if (dropdownData) {
      setFormData({
        dropdownCategory: dropdownData.dropdownCategory || '',
        label: dropdownData.label || '',
        value: dropdownData.value || '',
        order: dropdownData.order || 1,
        status: dropdownData.status || 'Active',
        createdDate: dropdownData.createdDate || '24-09-2025'
      })
    }
  }, [dropdownData])

  const handleBack = () => {
    navigate('/settings/dropdown-master')
  }

  const handleEdit = () => {
    navigate('/settings/dropdown-master/edit', { state: { rowData: dropdownData } })
  }

  return (
    <div className="page-container">
      <div className="page-content">
        {/* Breadcrumb Navigation */}
        <div className="breadcrumb-section">
          <nav className="breadcrumb-nav">
            <button className="breadcrumb-item" onClick={() => navigate('/settings')}>
              <span>Settings</span>
            </button>
            <ChevronRight size={14} className="breadcrumb-separator" />
            <button className="breadcrumb-item" onClick={() => navigate('/settings?tab=masters')}>
              <span>Masters</span>
            </button>
            <ChevronRight size={14} className="breadcrumb-separator" />
            <span className="breadcrumb-current">Dropdown Master</span>
          </nav>
        </div>

        {/* Header Section */}
        <div className="page-header">
          <div className="header-left">
            <button className="back-btn" onClick={handleBack}>
              <ArrowLeft size={20} />
            </button>
            <div className="page-title">
              <h1>Dropdown Master</h1>
              <p>Manage dropdown options and lists used across the application</p>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="card">
          <div className="form-header-dark">
            <h2>View Dropdown Master</h2>
          </div>
          <div className="card-body">
            <form className="form-content">
              <div className="grid-row-3">
                <div className="form-group">
                  <label htmlFor="dropdownCategory" className="form-label">
                    Dropdown Category
                  </label>
                  <input
                    type="text"
                    id="dropdownCategory"
                    name="dropdownCategory"
                    value={formData.dropdownCategory}
                    readOnly
                    className="form-input readonly-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="label" className="form-label">
                    Label
                  </label>
                  <input
                    type="text"
                    id="label"
                    name="label"
                    value={formData.label}
                    readOnly
                    className="form-input readonly-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="value" className="form-label">
                    Value
                  </label>
                  <input
                    type="text"
                    id="value"
                    name="value"
                    value={formData.value}
                    readOnly
                    className="form-input readonly-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="order" className="form-label">
                    Order
                  </label>
                  <input
                    type="text"
                    id="order"
                    name="order"
                    value={formData.order}
                    readOnly
                    className="form-input readonly-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="status" className="form-label">
                    Status
                  </label>
                  <input
                    type="text"
                    id="status"
                    name="status"
                    value={formData.status}
                    readOnly
                    className="form-input readonly-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="createdDate" className="form-label">
                    Created Date
                  </label>
                  <input
                    type="text"
                    id="createdDate"
                    name="createdDate"
                    value={formData.createdDate}
                    readOnly
                    className="form-input readonly-input"
                  />
                </div>
              </div>

              {/* Action Buttons */}
              <div className="form-actions">
                <button
                  type="button"
                  onClick={handleEdit}
                  className="btn-save"
                >
                  <Edit size={16} />
                  Edit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DropdownMasterView
